// import { isNumber } from "@turf/turf";
import { reactive, onMounted, computed, toRefs } from '@vue/composition-api'

/**
 * @description table 页面表格操作方法封装
 * @param {Function} api 获取表格数据 api 方法(必传)
 * @param {Object} initParam 获取数据初始化参数(非必传，默认为{})
 * @param {Boolean} isPageable 是否有分页(非必传，默认为true)
 * @param {Function} dataCallBack 对后台返回的数据进行处理的方法(非必传)
 * @param {Function} isInvokeOnce 是否调用一次
 * */

export const useTableList = (
  api,
  initParam,
  isPageable = true,
  dataCallBack,
  isInvokeOnce = true
) => {
  /**
   * 设计思路(首先要知道这个hook要输出的产物是什么？)
   * 产物：1.获取表格数据的方法getTableData
   * 产物：2.查询条件变量searchParam
   * 产物：3.分页查询条件变量pagination
   * 产物：4.分页pageSize变更的方法handleSizeChange()
   * 产物：5.分页currentPage变更的方法handleCurrentChange()
   * 产物：6.查询方法search()
   * 产物：7.初始化参数的变量searchInitParam
   */

  const state = reactive({
    loading: false,

    // 表格数据
    tableData: [],

    // 分页数据
    localPage: {
      // 当前页数
      currentPage: 1,
      // 每页显示条数
      pageSize: 10,
      // 总条数
      total: 0,
      pageSizes: [10, 30, 50, 100]
    },

    // 查询参数(只包括查询)
    searchParam: {
      status: null
    },

    // 初始化默认的查询参数
    searchInitParam: {},

    // 总参数(包含分页和查询参数)
    totalParam: {}
  })

  const pageParam = computed({
    get: () => {
      return {
        current: state.localPage.currentPage,
        page: state.localPage.currentPage,
        pageSize: state.localPage.pageSize,
        size: state.localPage.pageSize
      }
    },
    set: (newVal) => {
      console.log('我是分页更新之后的值', newVal)
    }
  })

  const getTableData = async () => {
    try {
      // 合并查询参数
      Object.assign(
        state.totalParam,
        isPageable ? pageParam.value : {},

        state.searParm
      )

      state.loading = true
      let { code, data } = await api(state.totalParam)
      if (code !== 0) {
        state.tableData = []
        return
      }
      // 回调处理，此处可以满足对特殊数据的处理
      dataCallBack && (data = dataCallBack(data))
      // 根据是否分页，进行赋值
      state.tableData = isPageable ? data.records : data

      // 对分页参数进行更新
      const { current: page, size: pageSize, total } = data
      isPageable && updatepagination({ page, pageSize, total })
    } catch (err) {
    } finally {
      state.loading = false
    }
  }
  const updatepagination = (resPageable) => {
    Object.assign(state.localPage, resPageable)
  }
  const updatedTotalParam = () => {
    state.totalParam = {}
    // 处理查询参数，可以给查询参数加自定义前缀操作
    const nowSearchParam = {}
    // 防止手动清空输入框携带参数（这里可以自定义查询参数前缀）
    for (const key in state.searchParam) {
      // * 某些情况下参数为 false/0 也应该携带参数
      if (
        state.searchParam[key] ||
        state.searchParam[key] === false ||
        state.searchParam[key] === 0
      ) {
        nowSearchParam[key] = state.searchParam[key]
      }
    }

    Object.assign(state.totalParam, nowSearchParam, isPageable ? pageParam.value : {})
  }

  const search = () => {
    state.localPage.currentPage = 1
    updatedTotalParam()
    getTableData()
  }

  const reset = () => {
    state.searchInitParam = {
      ...initParam
    }

    state.searchParam = {
      ...initParam
    }

    // state.searchParam = {};
    // 重置搜索表单的时，如果有默认搜索参数，则重置默认的搜索参数
    // Object.keys(state.searchInitParam).forEach((key) => {
    //   state.searchParam[key] = state.searchInitParam[key];
    // });

    search()
  }
  const refreshCurrentPage = () => {
    getTableData()
  }

  onMounted(() => {
    if (isInvokeOnce) {
      reset()
    }
  })

  const handleSizeChange = (val) => {
    state.localPage.currentPage = 1
    state.localPage.pageSize = val
    getTableData()
  }

  const handleCurrentChange = (val) => {
    state.localPage.currentPage = val
    getTableData()
  }

  const handlerChangePage = (params) => {
    const { current = 1, pageSize = 10, type = 'fresh' } = params || {}
    if (type === 'currentChange' || type === 'fresh') {
      handleCurrentChange(current)
    }
    if (type === 'sizeChange') {
      handleSizeChange(pageSize)
    }
  }
  const pageState = computed(() => {
    return {
      ...state.localPage,
      current: state.localPage.currentPage,
      page: state.localPage.currentPage,
      size: state.localPage.pageSize
    }
  })
  return {
    ...toRefs(state),
    pageState,
    getTableData,
    handleCurrentChange,
    handleSizeChange,
    search,
    reset,
    refreshCurrentPage,
    handlerChangePage
  }
}
